<template>
  <input-widget :model="model" :attribute="attribute" :items="negotiationStatuses" type="select2"
                display-field="${item.key}" value-field="value" :disabled="disabled"
                :options="{placeholder: $t('Select')}"/>

</template>

<script>
  import InputWidget from "@/core/components/input-widget/InputWidget";
  import {createNamespacedHelpers} from "vuex";

  const {mapState: globalMapState} = createNamespacedHelpers('global');
  export default {
    name: "NegotiationStatusSelectInputWidget",
    components: {InputWidget},
    computed: {
      ...globalMapState({
        negotiationStatuses: state => state.negotiationStatuses,
      }),
    },
    props: {
      model: {
        type: Object,
        required: true,
      },
      attribute: {
        type: String,
        required: true,
      },
      disabled: {
        type: Boolean,
        default: false
      },
    },
    methods: {

    }
  }
</script>

<style scoped>

</style>
